import {
  ApolloClient, ApolloLink, createHttpLink, InMemoryCache
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { authService } from '@nsd/fe';
import history from 'src/utils/history';
import CamelCase from '../CamelCase';

class GraphQLClient {
  constructor(uri) {
    this.createClient(uri);
  }

  createClient(uri) {
    const authLink = setContext((_, { headers }) => {
      // get the authentication token from local storage if it exists
      const token = authService.getAccessToken();// localStorage.getItem('accessToken');
      // return the headers to the context so httpLink can read them
      return {
        headers: {
          ...headers,
          'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY,
          authorization: token ? `Bearer ${token}` : ''
        }
      };
    });

    const httpLink = createHttpLink({
      uri: uri || `${process.env.REACT_APP_DISPATCH_QORE_API}/graphql` || 'http://localhost:7071/graphql',
      credentials: 'include'
    });

    const caseLink = new ApolloLink((operation, forward) => forward(operation)
      .map((data) => {
        // return CamelCase(data);
        CamelCase();
        return data;
      }));

    const errorLink = onError(({
      graphQLErrors,
      networkError,
      operation,
      response,
      forward
    }) => {
      console.log('errorLink: operation', operation);
      if (graphQLErrors) {
        graphQLErrors.forEach((err) => {
          const {
            message,
            locations,
            path
          } = err;
          switch (err.extensions.code) {
            case 'UNAUTHENTICATED':
              if (window.location.pathname !== '/403') {
                // Client-side navigation preserves the app shell (redux
                // store, Five9 iframe/session, log panel). A hard
                // `window.location.href` would full-reload the page.
                history.push('/403');
              }
              break;
            default:
              console.log('response', response);
              console.log('message', message);
              console.log('locations', locations);
              console.log('path', path);
              break;
          }
        });
      }

      if (networkError) {
        console.log(networkError);
        console.log(`[Network error]: ${networkError}`);
      }
    });

    const cache = new InMemoryCache({
      addTypename: false
    });

    this.client = new ApolloClient({
      link: errorLink.concat(authLink)
        .concat(caseLink)
        .concat(httpLink),
      cache
    });
  }
}

export default GraphQLClient;
